"use client"

import "../lib/cookieScript"
import { getT } from "@local/i18n/src/t"
import { getLanguageForMarket } from "@local/i18n/src/languages"
import { a11y } from "@local/i18n/src/catalogs/a11y"

interface CookiePreferencesButtonProps {
  name: string
  className?: string
  market?: string
}

const DEFAULT_CLASS =
  "cursor-pointer text-left text-base whitespace-nowrap focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"

export const CookiePreferencesButton = ({
  name,
  className,
  market,
}: CookiePreferencesButtonProps) => {
  const t = getT(getLanguageForMarket(market), { a11y })

  const handleClick = () => {
    if (typeof window === "undefined") {
      return
    }
    window.CookieScript?.instance?.show?.()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={t("a11y.openCookiePreferences")}
      className={className ?? DEFAULT_CLASS}
    >
      {name}
    </button>
  )
}
